export default __webpack_public_path__ + "static/media/FAC1.ba03e26b.webp";